import { Component } from '@angular/core';
import { CommonSharedModule } from '../../common/shared.module';
import { EventSearchType } from '../../../models/_enum-collections';
import { EngagementTableComponent } from '../engagement-table/engagement-table.component';

@Component({
  selector: 'app-all-engagements',
  templateUrl: './all-engagements.component.html',
  styleUrls: ['./all-engagements.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EngagementTableComponent]
})
export class AllEngagementsComponent {
  loading!: boolean;

  get EventSearchType(): typeof EventSearchType {
    return EventSearchType;
  }
}
